import axios from "axios";
import {
  awsUrl,
  url,
  newApiBaseUrl,
  tshuvApi,
  BaseUrl,
} from "../../axiosInstance";
import * as actionType from "../store/action";

export const getCoupons = () => {
  return axios
    .get(`${url}coupons`)
    .then((res) => res.data)
    .catch((e) => console.log(e));
};

export const createCoupon = (data) => {
  return axios.post(`${url}Coupon/AddCoupon`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const useCoupon = (couponCode, customerId, orderId) => {
  return axios
    .post(
      `${url}Coupon/RedeemCoupon?couponCode=${couponCode}&customerId=${customerId}&orderId=${orderId}`,
      {
        headers: {
          Authorization: `bearer ${localStorage.token}`,
          "Access-Control-Allow-Origin": "*",
        },
      },
    )
    .then((res) => res.data)
    .catch((e) => console.log(e));
};

export const getCostumerCoupons = (customerId) => {
  return axios
    .get(`${url}coupons?customerId=${customerId}`, {
      headers: {
        Authorization: `bearer ${localStorage.token}`,
        "Access-Control-Allow-Origin": "*",
      },
    })
    .then((res) => res.data)
    .catch((e) => console.log(e));
};
